<script setup>
import { onMounted, onUnmounted } from 'vue'
import { api } from '@/api/client.js'

// Tracks whether we've already injected so HMR / re-mounts don't duplicate tags.
let injected = false

function injectAnalytics(htmlCode) {
  if (!htmlCode || injected) return
  // Admin saves the full HTML snippet from Google with two script tags (gtag loader + init call).
  // We cannot stick that into innerHTML because script tags appended via innerHTML do not execute —
  // re-create each one via createElement so the browser runs them.
  const tmp = document.createElement('div')
  tmp.innerHTML = htmlCode
  tmp.querySelectorAll('script').forEach(oldScript => {
    const s = document.createElement('script')
    for (const attr of oldScript.attributes) s.setAttribute(attr.name, attr.value)
    s.textContent = oldScript.textContent
    s.dataset.siteAnalytics='true';document.head.appendChild(s)
  })
  injected = true
}

let analyticsCode=''
function applyConsent(){let allowed=false;try{allowed=JSON.parse(localStorage.getItem('evoluxu-cookie-ack-v2')||'{}').analytics===true}catch{};if(allowed)injectAnalytics(analyticsCode);else{document.querySelectorAll('[data-site-analytics]').forEach(s=>s.remove());injected=false}}
onMounted(()=>window.addEventListener('cookie-consent-changed',applyConsent))
onUnmounted(()=>window.removeEventListener('cookie-consent-changed',applyConsent))
onMounted(async () => {
  if (import.meta.env.DEV) return  // don't pollute analytics during local dev
  try {
    const { data } = await api.get('/api/settings')
    const code = data?.googleAnalyticsCode || data?.google_analytics || ''
    analyticsCode=code;applyConsent()
  } catch {}
})
</script>

<template><div class="hidden" aria-hidden="true"></div></template>

<style scoped>
.hidden { display: none; }
</style>
